
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnCheck from "@/components/scope/btn-check.vue";
import dayjs from "dayjs";
import { priceRulesEl, mobileRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";

const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const common_app = namespace("common_app");
const base = namespace("base");
const inventory = namespace("inventory");
const supplier = namespace("supplier");
const purchase = namespace("purchase");
const setting = namespace("setting");

@Component({
  components: { BtnCheck }
})
export default class PurchaseRefundEdit extends Vue {
  @purchase.Action getPurchaseModel;
  @purchase.Action getPurchaseSelectModelList;
  @purchase.Action outBoundReturnPurchase;
  @purchase.Action saveReturnPurchase;
  @app.Mutation setPBPX;
  @supplier.Action getSupplierList;
  @supplier.Action getSupplierDetail;
  @supplier.Action createSupplier;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @inventory.Action queryInventoryAndNotice;
  @parts.Action getPartsDetail;
  @inventory.Action getInventoryListByParts;
  @purchase.Action getReturnPurchaseModel;
  @purchase.Action purchaseComplete;
  @purchase.Action getPurchaseDetail;
  @user.State userData;
  @base.Action getDictionaryList;
  @purchase.Action savePurchase;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_app.State country;
  @inventory.Action queryWarehouseByInventory;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    return [
      { name: t("v210901.purchase-return"), path: "/purchase/refund-index" },
      {
        name: this.isAdd ? t("v210901.new-purchase-return") : t("v210901.edit-purchase-return")
      }
    ];
  }
  get additionalData() {
    return [
      {
        additionalFees: this.orderFormData.additionalFees,
        additionalFeesRemark: this.orderFormData.additionalFeesRemark
      }
    ];
  }
  get isAdd() {
    return this.$route.name === "purchaseRefundAdd";
  }
  get purchaseOrder() {
    return this.$route.query.order;
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  inputSearchKey: any = "";
  handleSearchInput(queryString, cb) {
    this.getPurchaseSelectModelList({ searchKey: this.inputSearchKey }).then(data => {
      let list = data.data.slice(0, 10).map(v => {
        return { value: `${v.supplierName} / ${v.purchaseNo} / ${v.partsNameDesc}`, ...v };
      });
      cb(list);
    });
  }
  resultDetail: any = null;
  handleSelectInput(item) {
    this.getPurchaseModel({ purchaseNo: item.purchaseNo }).then(data => {
      data.data.purchaseInboundDetailList.forEach(element => {
        element.returnQty = "";
        element.returnPrice = "";
      });
      this.resultDetail = data.data;
      if (!this.resultDetail.purchaseUserName) {
        this.resultDetail.purchaseUserName = this.userData.firstName;
      }
      this.orderFormData.returnPurchaseDetailList = this.resultDetail.purchaseInboundDetailList;
      this.orderFormData.returnPurchaseDetailList.forEach((item, index) => {
        let element = JSON.parse(JSON.stringify(item));
        item.returnQty = element.returnableQuantity;
        item.returnPrice = element.costPrice;
        this.computedAmount(index);
      });
      this.orderFormData.additionalFees = "";
      this.orderFormData.additionalFeesRemark = "";
      if (this.resultDetail.surplusAdditionalFees && Number(this.resultDetail.surplusAdditionalFees)) {
        this.showAdditional = true;
        this.orderFormData.additionalFees = this.resultDetail.surplusAdditionalFees;
      } else {
        this.showAdditional = false;
      }
      this.computedTotalAmount();
    });
  }
  blurForBug() {
    (document as any).activeElement.blur();
  }
  newSupplierDataRules: any = {
    supplierName: [{ required: true, message: t("setting.enter-supplier-name"), trigger: "blur" }],
    contactMobile: { validator: this.validateMobile, trigger: "blur" }
  };
  handleShowCreateSupplier() {
    this.showCreateSupplier = true;
    this.newSupplierData.supplierName = this.supplierSearchValue;
  }
  validateMobile(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      mobileRulesEl(value, callback);
    }
  }
  supplierSearchValue: string = "";
  get isEditUnitPrice() {
    return true;
  }
  showAdditional: boolean = false;
  advisorList: any[] = [{}];
  emptyToLine = emptyToLine;
  orderFormData: any = {
    additionalFees: "", // 附加费
    additionalFeesRemark: "", // 附加费备注
    purchaseNo: "", // 采购单号
    returnDate: "", // 退货日期, yyyyMMdd
    returnPurchaseDetailList: [], // 退货明细列表
    //          purchaseDetailNo  采购单明细编号
    //          remark  备注
    //          returnAmount  退货总价
    //          returnPrice  退货单价
    //          returnQty  退货数量
    returnPurchaseNo: "", // 退货单号
    returnReason: "", // 退货原因
    returnUserCode: "", // 退货人编码
    returnUserName: "" // 退货人名称
  };
  orderFormDataRules: any = {
    returnReason: { required: true, message: t("v210901.please-select-return-reason"), trigger: "change" },
    returnDate: { required: true, message: t("v210901.please-select-return-date"), trigger: "change" },
    returnUserCode: { required: true, message: t("v210901.please-select-the-returner"), trigger: "change" }
  };
  definitionPartsData: any = {
    partsInfo: {},
    amount: "",
    qty: "",
    totalInventory: 0,
    costPrice: "",
    partsCode: "",
    warehouseCode: "",
    remark: "",
    list: []
  };

  serviceItemList: any[] = [];
  showCreateSupplier: boolean = false;
  newSupplierData: any = {
    supplierName: "",
    contactName: "",
    contactMobile: ""
  };
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  handleConfirmCreateSupplier() {
    (this.$refs.addSupplierForm as any).validate(valid => {
      if (valid) {
        this.createSupplier(this.newSupplierData).then(data => {
          this.$message.success(t("v210831.success"));
          this.supplierList.push({
            supplierName: this.newSupplierData.supplierName,
            supplierCode: data.data.supplierCode
          });
          this.$nextTick(() => {
            this.orderFormData.supplierCode = data.data.supplierCode;
          });
          this.showCreateSupplier = false;
          this.handleSupplierChange(data.data.supplierCode);
        });
      }
    });
  }
  deleteAdditional() {
    this.showAdditional = false;
    this.orderFormData.additionalFees = "";
    this.orderFormData.additionalFeesRemark = "";
  }
  created() {
    this.setPBPX(100);
    this.init();
    // this.handleAddParts(); // 默认添加第一行
  }
  inWarehouseTypeList: any = [];
  supplierList: any = [];
  returnReasonList: any = [];
  searchSupplierList(val = "") {
    this.supplierSearchValue = val;
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      supplierName: val
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []);
    });
  }
  async init() {
    this.searchSupplierList();
    this.getDictionaryList("inbound_type").then(data => {
      this.inWarehouseTypeList = data.filter(item => item.dataValue !== "3");
    });
    this.getDictionaryList("return_reason").then(data => {
      this.returnReasonList = data;
    });
    this.getPartsLists();
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.getReturnPurchaseModel({
        returnPurchaseNo: this.orderId
      }).then(data => {
        this.orderFormData = data.data;
        this.orderFormData.returnDate = dayjs(this.orderFormData.returnDate).format("YYYYMMDD");
        if (this.orderFormData.additionalFees && Number(this.orderFormData.additionalFees)) {
          this.showAdditional = true;
        }
        this.getPurchaseModel({ purchaseNo: this.orderFormData.purchaseNo }).then(data => {
          this.resultDetail = data.data;
          let additionalFees = this.orderFormData.additionalFees || 0;
          let surplusAdditionalFees = this.resultDetail.surplusAdditionalFees || 0;
          this.resultDetail.surplusAdditionalFees = Number(additionalFees) + Number(surplusAdditionalFees);
          this.orderFormData.returnPurchaseDetailList.forEach((item, index) => {
            item.purchaseQuantity = item.purchaseQty;
            let element = this.resultDetail.purchaseInboundDetailList.find(v => v.partsCode === item.partsCode);
            if (element) {
              item.costPrice = element.costPrice;
              this.computedAmount(index);
            }
          });
          this.computedTotalAmount();
        });
      });
    } else {
      if (this.purchaseOrder) {
        this.getPurchaseSelectModelList({ searchKey: this.purchaseOrder }).then(data => {
          if (data.data && data.data[0]) {
            let item = data.data[0];
            this.inputSearchKey = `${item.supplierName} / ${item.purchaseNo} / ${item.partsNameDesc}`;
          } else {
            this.inputSearchKey = this.purchaseOrder;
          }
        });
        this.handleSelectInput({ purchaseNo: this.purchaseOrder });
      }
      this.orderFormData.returnDate = dayjs().format("YYYYMMDD");
      this.orderFormData.returnUserCode = this.userData.userCode;
      this.orderFormData.returnUserName = this.userData.firstName;
    }
    this.$forceUpdate();
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }
  computedAmount(index) {
    let amount =
      (this.orderFormData.returnPurchaseDetailList[index].returnQty || 0) *
      (this.orderFormData.returnPurchaseDetailList[index].returnPrice || 0);
    this.orderFormData.returnPurchaseDetailList[index].returnAmount = amount.i18nToFixed();
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    let partsTotal = this.orderFormData.returnPurchaseDetailList.reduce(
      (preV, curV) => preV + Number(curV.returnAmount || 0),
      0
    );
    let amount = partsTotal + Number(this.orderFormData.additionalFees || 0);
    if (Object.is(NaN, amount)) {
      this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.purchaseAmount = amount.i18nToFixed();
    this.$forceUpdate();
  }
  searchParts(val) {
    this.getPartsLists(val);
  }

  emitComplete(orderId?) {
    let purchaseNo = orderId || this.orderId;
    this.outBoundReturnPurchase({
      returnPurchaseNo: purchaseNo
    })
      .then(data => {
        this.$message.success(t("warehouse.outbound-success"));
        if (data.data.validateInventoryAlert === "1") {
          const partsCodeList = this.orderFormData.returnPurchaseDetailList.map(item => item.partsCode);
          if (partsCodeList && partsCodeList.length > 0) {
            this.queryInventoryAndNotice(partsCodeList);
          }
        }
        this.$router.push(`/purchase/purchase-refund-view/${purchaseNo}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleChooseParts(val, index, originData?) {
    let findData = this.partsList.find(item => item.partsCode === val);
    let definitionPartsData = originData || findData;
    this.getInventoryListByParts({
      partsCode: val
    }).then(data => {
      let partsData = Object.assign({}, definitionPartsData, {
        partsCode: val,
        partsInfo: definitionPartsData,
        list: this.$safeValue(data, "data.list", []),
        totalInventory: data.data.inventoryQty,
        costPrice: definitionPartsData.purchasePrice || "0.00"
      });
      this.orderFormData.purchaseInboundDetailList.splice(index, 1, partsData);
      this.computedAmount(index);
    });
  }

  checkAddData(): boolean {
    if (!this.resultDetail) {
      this.$message.error(t("v210901.please-select-associated"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.returnPurchaseDetailList.length; index++) {
      const element = this.orderFormData.returnPurchaseDetailList[index];
      if (!element.returnQty) {
        this.$message.error(t("v210901.please-enter-the-quantity"));
        return false;
      }
      if (!element.returnPrice) {
        this.$message.error(t("v210901.please-enter-the-unit-price"));
        return false;
      }
      if (Object.is(NaN, Number(element.returnAmount))) {
        this.$message.error(t("setting.enter-quantity-or-amount"));
        return false;
      }
      if (Number(element.returnQty) < 0) {
        this.$message.error(t("v210901.return-quantity-cannot"));
        return false;
      }
      if (Number(element.returnQty) > Number(element.returnableQuantity)) {
        this.$message.error(t("v210901.the-returned-quantity-tips"));
        return false;
      }
      if (Number(element.returnPrice) < 0) {
        this.$message.error(t("v210901.return-unit-price-not-negative"));
        return false;
      }
      if (Number(element.returnPrice) > Number(element.costPrice)) {
        this.$message.error(t("v210901.return-unit-price-tips"));
        return false;
      }
    }
    return true;
  }
  operationName: string = "";
  handleComplete() {
    this.operationName = "complete";
    this.emitSavePurchase();
  }
  handleSavePurchase() {
    this.operationName = "save";
    this.emitSavePurchase();
  }
  emitSavePurchase() {
    this.orderFormData.purchaseNo = this.resultDetail?.purchaseNo;
    (this.$refs["purchaseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        if (this.isAdd) {
          this.orderFormData.returnPurchaseNo = "";
          this.saveReturnPurchase(this.orderFormData)
            .then(data => {
              if (this.operationName === "save") {
                this.$message.success(t("v210831.saved-successfully"));
                this.$router.push(`/purchase/purchase-refund-view/${data.data["returnPurchaseNo"]}`);
              } else {
                this.emitComplete(data.data["returnPurchaseNo"]);
              }
            })
            .finally(() => {
              this.btnStopLoading();
            });
        } else {
          this.saveReturnPurchase(this.orderFormData)
            .then(() => {
              if (this.operationName === "save") {
                this.$message.success(t("v210831.saved-successfully"));
                this.$router.push(`/purchase/purchase-refund-view/${this.orderId}`);
              } else {
                this.emitComplete(this.orderId);
              }
            })
            .finally(() => {
              this.btnStopLoading();
            });
        }
      } else {
        console.log("error submit!!");
      }
    });
  }
  seletedSupplierData: any = {};
  handleSupplierChange(val) {
    if (!val) {
      this.seletedSupplierData = {};
    } else {
      this.getSupplierDetail({
        supplierCode: val
      }).then(data => {
        this.seletedSupplierData = data.data;
      });
    }
  }
  handleAddParts() {
    this.orderFormData.purchaseInboundDetailList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    this.orderFormData[key].splice(index, 1);
  }
  goBack() {
    this.$router.go(-1);
  }

  initWarehouseSelect(row) {
    this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      dimension: 10
    }).then(({ data }) => {
      row.warehouseList = data.itemList;
    });
  }
}
